export default function IsActive({onChange, checked}) {
  return (
    <div className="isActive">
      <label className="isActive_checkbox">
        <input type="checkbox" className="checkbox__input" onChange={onChange} checked={checked}/>
        <span className="checkbox__label"></span>
        Is Active
      </label>
    </div>
  );
}
